// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"ButtonWithSpinner_buttonWrapper__3BIYb","spinner":"ButtonWithSpinner_spinner__3ErqT","loadingButton":"ButtonWithSpinner_loadingButton__1CInc"};